import React from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";

import { formatDate, i18, trb } from "@utilities";
import { selectApplicationComments } from "@redux/Selectors";

export const DocumentCommentsTable = React.memo(() => {
  const comments = useSelector(selectApplicationComments);

  if (comments.length === 0) {
    return null;
  }

  const columns = [
    {
      title: trb(i18.ApplicationsLabels.Datetime),
      dataIndex: "date",
      key: "date",
      render: item => formatDate(item)
    },
    {
      title: trb(i18.ApplicationsLabels.Comment),
      dataIndex: "comment",
      key: "comment"
    },
    {
      title: trb(i18.ApplicationsLabels.DocumentClientComment),
      dataIndex: "clientComment",
      key: "clientComment"
    }
  ];

  return (
    <div className="mt-4">
      <Table
        className="w-100"
        dataSource={comments}
        columns={columns}
        scroll={{ x: "60vw" }}
        pagination={false}
        rowKey="id"
      />
    </div>
  );
});
